import HeadsetSvg from '@assets/images/svg/headset.svg';
import React from 'react';
import { View } from 'react-native';

export interface HeadsetIconProps {
    size?: number;
    color?: string;
}

export function HeadsetIcon({ size = 24, color = '#333333' }: HeadsetIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <HeadsetSvg width={size} height={size} color={color} />
        </View>
    );
}